import React, { useEffect } from 'react';
import DocumentTitle from 'react-document-title';
import { Col, Row } from 'reactstrap';
import ApiLoader from '../loading/ApiLoader';
import { useAxiosHook } from '../../hooks/ApiHooks';
import api from '../../apiConfig';
import { get } from 'lodash';
import routeList from '../../routes/routeList';
import Book from '../containers/Book';
import ReadingsPagination from '../utils/ReadingsPagination';
import SearchBox from '../containers/SearchBox';

const ReadingsCategoryList = ({ pageTitle, match, history, location }) => {
  const category = match.params.category;
  const id = match.params.id;
  const categoryName = get(location.state, 'category_name', '');

  const currPageNo = Number(match.params.no) || 1;

  const [categoryBooks, getCategoryBooks] = useAxiosHook(api.dataController, api.readingsData, 'get', null, {
    params: { taxonomy: category, taxonomy_id: id, page: currPageNo, per_page: 16 }
  });

  useEffect(() => {
    getCategoryBooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currPageNo]);

  const changePageNo = pageNo => {
    history.push(`${routeList.category}/${category}/${id}${pageNo === 1 ? '' : `/${pageNo}`}`);
  };

  const showBooks = (categoryBooks.data && categoryBooks.data.elements) || [];
  const totalPages = (categoryBooks.data && categoryBooks.data.totalPages) || 0;

  return (
    <div className="full-wrapper flex-grow-1 subpage-margins">
      <ApiLoader status={categoryBooks.apiStatus}>
        <DocumentTitle title={pageTitle} />
        <section className="content-wrapper">
          <SearchBox />
          {categoryName && (
            <h1 className="main-header">
              <span>Lista lektur dla kategorii: </span> {categoryName}
            </h1>
          )}
          {showBooks.length === 0 && <h4 className="text-center">Brak lektur w wybranej kategorii</h4>}
          <Row>
            {showBooks.map((book, idx) => (
              <Col xs="12" sm="6" lg="3" key={idx} className="mb-30">
                <Book title={book.title} author={book.author_book_link} cover={book.book_cover} slug={book.slug} />
              </Col>
            ))}
          </Row>
          <ReadingsPagination totalPages={totalPages} currPageNo={currPageNo} changePageNo={changePageNo} />
        </section>
      </ApiLoader>
    </div>
  );
};

export default ReadingsCategoryList;
